var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Tooltip from "bootstrap-vue/es/directives/tooltip/tooltip";
import { ImageData, getCropUrl } from "../Helpers/Image.ts";
var sizes = {
    sm: {
        width: 40,
        height: 40
    },
    lg: {
        width: 100,
        height: 100
    }
};
var ProfilePicture = /** @class */ (function (_super) {
    __extends(ProfilePicture, _super);
    function ProfilePicture() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.img = null;
        return _this;
    }
    ProfilePicture.prototype.onSizeChanged = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.reset()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        }); });
    };
    ProfilePicture.prototype.onbytesChanged = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.reset()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        }); });
    };
    ProfilePicture.prototype.onCropChanged = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.reset()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        }); });
    };
    Object.defineProperty(ProfilePicture.prototype, "desiredSize", {
        get: function () {
            return sizes[this.size];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProfilePicture.prototype, "avatarUrl", {
        get: function () {
            var _this = this;
            return this.avatar
                ? getCropUrl(this.avatar.src, this.avatar.crops.filter(function (p) { return p.alias === "avatar-" + _this.size; }).filter(function (p) { return p.coordinates; }).map(function (p) { return p.coordinates; })[0], this.desiredSize)
                : this.url;
        },
        enumerable: true,
        configurable: true
    });
    ProfilePicture.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reset()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProfilePicture.prototype.reset = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.bytes) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, ImageData.create(this.bytes, this.desiredSize, this.crop)];
                    case 1:
                        _a.img = _c.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(this.url && this.crop)) return [3 /*break*/, 4];
                        _b = this;
                        return [4 /*yield*/, ImageData.create(this.url, this.desiredSize, this.crop)];
                    case 3:
                        _b.img = _c.sent();
                        _c.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ProfilePicture.prototype, "croppedSize", {
        get: function () {
            if (!this.img)
                return { width: 0, height: 0 };
            return this.img.scale(this.img.initialScale);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProfilePicture.prototype, "croppedOffset", {
        get: function () {
            if (!this.img)
                return { x: 0, y: 0 };
            return this.img.center(this.img.cropCenter, this.desiredSize, this.img.initialScale);
        },
        enumerable: true,
        configurable: true
    });
    ProfilePicture.prototype.pixelize = function (value) {
        return value
            ? value + "px"
            : value;
    };
    __decorate([
        Prop({ type: String, default: "sm", validator: function (value) { return value && ["sm", "lg"].indexOf(value.toLowerCase()) !== -1; } })
    ], ProfilePicture.prototype, "size", void 0);
    __decorate([
        Watch("size")
    ], ProfilePicture.prototype, "onSizeChanged", null);
    __decorate([
        Prop({ type: String })
    ], ProfilePicture.prototype, "url", void 0);
    __decorate([
        Prop({ type: String })
    ], ProfilePicture.prototype, "bytes", void 0);
    __decorate([
        Watch("bytes")
    ], ProfilePicture.prototype, "onbytesChanged", null);
    __decorate([
        Prop({ type: Object })
    ], ProfilePicture.prototype, "crop", void 0);
    __decorate([
        Watch("crop")
    ], ProfilePicture.prototype, "onCropChanged", null);
    __decorate([
        Prop({ type: Object })
    ], ProfilePicture.prototype, "avatar", void 0);
    __decorate([
        Prop({ type: String })
    ], ProfilePicture.prototype, "fullName", void 0);
    ProfilePicture = __decorate([
        Component({
            name: "ProfilePicture",
            directives: {
                "b-tooltip": Tooltip
            }
        })
    ], ProfilePicture);
    return ProfilePicture;
}(Vue));
export default ProfilePicture;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/ProfilePicture.vue
// module id = 793
// module chunks = 24